export default {
  required: '请输入',
  requiredSelect: '请选择',
  basicInfo: '基础信息',
  providerType: '服务商类型',
  providerTypeCustom: '自定义',
  serverType: '服务器API/SMTP',
  serverTypeAPI: 'API',
  serverTypeSMTP: 'SMTP',
  apiKey: 'API',
  apiKeyPlaceholder: '请输入邮箱服务API',
  apiSecret: 'API SECRET',
  apiSecretPlaceholder: '请输入邮箱服务API secret',
  smtpHost: '服务器地址（SMTP）',
  smtpHostPlaceholder: '请输入邮箱服务器地址',
  smtpPort: '端口号（Port）',
  smtpPortPlaceholder: '请输入端口号（例如：457或587）',
  encryption: '加密协议',
  encryptionSSL: 'SSL',
  encryptionTLS: 'TLS',
  encryptionNone: 'None',
  senderPassword: '发件人密码/授权码',
  senderPasswordPlaceholder: '请输入授权密码',
  senderEmail: '发件人邮箱地址',
  senderEmailPlaceholder: '请输入发件人邮箱地址',
  senderName: '发件人用户名',
  senderNamePlaceholder: '请输入发件人用户名',
  sendTest: '邮件发送测试',
  testRecipient: '测试收件人邮箱',
  testRecipientPlaceholder: '请输入收件邮箱',
  sendTestEmail: '发送测试邮件',
  sendTestSuccess: '测试邮件发送成功',
  sendTestFail: '测试邮件发送失败',
  save: '保存配置',
  saveSuccess: '保存成功',
  sendLog: '邮件发送记录',
  logSendTime: '发送时间',
  logRecipient: '收件人',
  logStatus: '状态',
  logTemplateName: '模板名称',
};
